(()=>{
  const hosts={nl:'www.mineralissima.nl',en:'en.mineralissima.nl',de:'de.mineralissima.nl',fi:'fi.mineralissima.nl',da:'www.mineralissima.nl'};
  const update=()=>{
    const alternates=[...document.head.querySelectorAll('link[rel="alternate"][hreflang]')];
    document.querySelectorAll('[data-mi-language]').forEach(link=>{
      const code=link.dataset.miLanguage;
      const alternate=alternates.find(item=>item.hreflang.toLowerCase().split('-')[0]===code&&new URL(item.href).hostname===hosts[code]);
      const url=new URL(alternate?alternate.href:`https://${hosts[code]}/${code==='da'?'da-dk/':''}`);
      const preview=new URLSearchParams(location.search).get('preview_theme_id');
      if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
      if(url.hostname===location.hostname&&url.pathname===location.pathname)url.hash=location.hash;
      link.href=url.href;
    });
  };
  update();
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('click',event=>{
    document.querySelectorAll('[data-mi-language-switcher][open]').forEach(item=>{if(!item.contains(event.target))item.open=false;});
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-mi-language-switcher][open]').forEach(item=>{item.open=false;item.querySelector('summary').focus();});
  });
})();
